export const sortArrayByOrderSequence = <T extends unknown>(array: T[]) => {
    let result = array.sort(
        (itemA, itemB) =>
            (itemA as any).orderSequence - (itemB as any).orderSequence
    )
    return result
}
